import request from '@/request';

export default {
  /**
   * params: id: priv_003 钻石，priv_006白金，priv008黄金
   *         buyType: 1 常旅客包，0抢票包
   */
  331406: ( params ) => {
    return request.ticket({
      url: '/gateway/gtgj/act',
      auth: 'yes',
      data: Object.assign({
        pid: 331406
      }, params),
      sidFields: ['uid', 'id', 'buyType']
    })
  }
}


// WEBPACK FOOTER //
// ./src/projects/vipCard/service/vipOrder.js